const actionTypes = {
  getPracticeProfile: 'GET_PRACTICE_PROFILE',
  getPracticeProfileSuccess: 'GET_PRACTICE_PROFILE_SUCCESS',
  getPracticeProfileFailure: 'GET_PRACTICE_PROFILE_FAILURE',
  setActivePatient: 'SET_ACTIVE_PATIENT',
  setGuardian: 'SET_GUARDIAN',
};

const actions = {
  getPracticeProfile: id => ({
    type: actionTypes.getPracticeProfile,
    payload: {
      id,
    },
  }),
  getPracticeProfileSuccess: profile => ({
    type: actionTypes.getPracticeProfileSuccess,
    payload: {
      profile,
    },
  }),
  getPracticeProfileFailure: error => ({
    type: actionTypes.getPracticeProfileFailure,
    payload: { error },
    error: true,
  }),
  setActivePatient: patient => ({
    type: actionTypes.setActivePatient,
    payload: { patient },
  }),
  setGuardian: guardian => ({
    type: actionTypes.setGuardian,
    payload: { guardian },
  }),
};

export { actions, actionTypes };
